import { randomUUID } from 'expo-crypto';
import { useCartLiveValidationActions } from 'features/cart/hooks/use-cart-live-validation-actions';
import { useMinimalCart } from 'features/cart/hooks/use-minimal-cart';
import { ICartEntry, MinimalCartEntryType } from 'features/cart/types';
import { Icon } from 'ucl/components/icon/Icon';

import { t } from 'state/intl/translations';
import { getServiceModeFromLS } from 'state/service-mode';
import { useUnifiedMenuContext } from 'state/unified-menu/unified-menu-context';

import { logCartAddToCart, logCartItemDuplicated } from '../../utils/analytics';

import { CartEntryActionButton } from './cart-entry-action-button';

export const CartEntryDuplicateButton = ({
  cartEntry,
  disabled,
  quantityOnCart,
}: {
  cartEntry: ICartEntry;
  disabled?: boolean;
  quantityOnCart?: number;
}) => {
  const { indexedMenu } = useUnifiedMenuContext();
  const { addItemToMinimalCart, cartEntries } = useMinimalCart();
  const { requestCartValidation } = useCartLiveValidationActions();
  const menuEntry = indexedMenu.find(cartEntry.id);
  const maxCartQuantity = menuEntry?.quantity?.max;
  const maxCartQuantityMet =
    quantityOnCart != null && maxCartQuantity != null && quantityOnCart >= maxCartQuantity;
  const isDisabled = disabled || maxCartQuantityMet;

  const handleDuplicate = () => {
    logCartItemDuplicated();
    const serviceMode = getServiceModeFromLS();
    const newCartEntry = {
      ...cartEntry,
      cartId: randomUUID(),
    };
    if (serviceMode) {
      logCartAddToCart({
        cartEntry: newCartEntry,
        previousCartEntries: cartEntries,
        serviceMode,
      });
    }
    addItemToMinimalCart(newCartEntry);
    requestCartValidation();
  };

  if (cartEntry.type === MinimalCartEntryType.incentive) {
    return null;
  }
  if (
    cartEntry.type === MinimalCartEntryType.reward &&
    cartEntry.children?.[0]?.type === MinimalCartEntryType.combo
  ) {
    return null;
  }

  return (
    <CartEntryActionButton
      disabled={isDisabled}
      accessibilityLabel={`${t('duplicate')} ${cartEntry.name} `}
      testID="duplicate-cart-entry-button"
      icon={<Icon name="custom:DuplicateItem" size="md" />}
      onPress={handleDuplicate}
    />
  );
};
